import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { ReactRelayContext } from 'react-relay';
import serverVars from 'server-vars';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { shopRoot } from '../shop/shopRoot';
import { collectionsLandingRoot } from '../shop/collectionsLandingRoot';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import tracking from 'dibs-tracking';
import { ShopWrapper } from '../shop/ShopWrapper';
import { getRelayEnvironment } from '../utils/relayModernEnvironment';
import get from 'lodash.get';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));
const variables = serverVars.get('relayVariables');
const query = serverVars.get('isCollections') ? collectionsLandingRoot : shopRoot;

const operation = createOperationDescriptor(getRequest(query), variables);
const snapshot = environment.lookup(operation.fragment, operation);
const { data } = snapshot;

initializeDBL().then(() => {
    ReactDOM.render(
        <IntlProvider
            locale={serverVars.get('localeDataKey')}
            messages={serverVars.get('messages')}
        >
            <ReactRelayContext.Provider
                value={{
                    environment,
                    variables: snapshot.variables || {},
                }}
            >
                <ShopWrapper landingPage={get(data, 'viewer.landingPage')} />
            </ReactRelayContext.Provider>
        </IntlProvider>,
        document.getElementById('js-root')
    );
    tracking.trackPageview();
});
